import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-707c728f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lp-card mplaylist" }
const _hoisted_2 = { class: "mplaylist__head" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "mplaylist__progress" }
const _hoisted_5 = { class: "lp-bar" }
const _hoisted_6 = { class: "mplaylist__list" }
const _hoisted_7 = {
  key: 0,
  class: "mplaylist__item mplaylist__item--locked"
}
const _hoisted_8 = { class: "mplaylist__state" }
const _hoisted_9 = { class: "mplaylist__text" }
const _hoisted_10 = { class: "mplaylist__title" }
const _hoisted_11 = { class: "mplaylist__meta" }
const _hoisted_12 = { class: "mplaylist__state" }
const _hoisted_13 = { class: "mplaylist__text" }
const _hoisted_14 = { class: "mplaylist__title" }
const _hoisted_15 = { class: "mplaylist__meta" }
const _hoisted_16 = { class: "mplaylist__footer" }

import { computed } from 'vue';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { useCourseI18n } from '../course';


export default /*#__PURE__*/_defineComponent({
  props: {
    module: null,
    moduleNumber: null,
    modulesTotal: null,
    currentLessonId: null,
    locked: { type: Boolean },
    nextModule: null
  },
  setup(__props: any) {

const props = __props as {
  module: any
  moduleNumber: number | null
  modulesTotal: number
  currentLessonId: number | null
  locked: boolean
  nextModule: any | null
}



const { tc } = useCourseI18n();

const lessons = computed<any[]>(() => props.module.lessons || []);
const done = computed(() => lessons.value.filter(lesson => lesson.is_started).length);
const percent = computed(() => lessons.value.length ? (done.value / lessons.value.length) * 100 : 0);
const courseRoute = computed(() => ({ name: 'training-module-list', params: { id: props.module.course?.id } }));
const lessonRoute = (lesson: any) => ({ name: 'training-module-show-lesson', params: { id: props.module.id, lesson_id: lesson.id } });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.moduleNumber)
        ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_unref(tc)('module_of', { current: __props.moduleNumber, total: __props.modulesTotal })), 1))
        : _createCommentVNode("", true),
      _createElementVNode("h3", null, _toDisplayString(__props.module.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("span", {
            style: _normalizeStyle({ width: `${_unref(percent)}%` })
          }, null, 4)
        ]),
        _createElementVNode("span", null, _toDisplayString(_unref(tc)('watched_count', { done: _unref(done), total: _unref(lessons).length })), 1)
      ])
    ]),
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lessons), (lesson, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: lesson.id
        }, [
          (__props.locked)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(HcIcon, {
                    name: "lock",
                    size: 15
                  })
                ]),
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(lesson.title), 1),
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(HcIcon, {
                      name: "video",
                      size: 13
                    }),
                    _createTextVNode(_toDisplayString(_unref(tc)('lesson_label', { n: index + 1 })), 1)
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: lessonRoute(lesson),
                class: _normalizeClass(["mplaylist__item", {
            'mplaylist__item--done': lesson.is_started,
            'mplaylist__item--current': lesson.id === __props.currentLessonId,
          }])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_12, [
                    (lesson.is_started)
                      ? (_openBlock(), _createBlock(HcIcon, {
                          key: 0,
                          name: "check",
                          size: 12
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(lesson.title), 1),
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(HcIcon, {
                        name: "video",
                        size: 13
                      }),
                      _createTextVNode(_toDisplayString(_unref(tc)('lesson_label', { n: index + 1 })), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to", "class"]))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_16, [
      (__props.nextModule)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'training-module-show', params: { id: __props.nextModule.id } },
            class: "mplaylist__link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(tc)('next_module_named', { title: __props.nextModule.title })), 1),
              _createVNode(HcIcon, {
                name: "chevron-right",
                size: 14
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: _unref(courseRoute),
        class: "mplaylist__link"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_unref(tc)('all_modules')), 1),
          _createVNode(HcIcon, {
            name: "chevron-right",
            size: 14
          })
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})